import { css, polished } from 'jimu-core';
export const tagInputStyles = (props) => {
    const theme = props.theme;
    return css `
    width: 100%;
    border-radius: 2px;
    background: ${theme === null || theme === void 0 ? void 0 : theme.ref.palette.neutral[300]};
    box-sizing: border-box;
    padding: ${polished.rem(6)};
    position: relative;
    .tag-input-dropdown {
      width: 100%;
      .tag-text-input-container {
        padding-bottom: ${polished.rem(10)};
        padding: 0px;
        .tag-text-input {
          font-size: ${polished.rem(13)};
          border: none;
          .input-wrapper {
            outline: none;
            outline-offset: -2px;
            > input {
              white-space: normal;
            }
          }
        }
      }
    }
  `;
};
